import { Content } from '@prismicio/client';
import { Simplify } from '../../../../../prismicio-types';

import styles from './careerCards.module.scss';
import { OptimizedPrismicImage } from '@/components';

interface CareerCardsProps {
  data: Simplify<Content.CareersSliceDefaultPrimary>;
  isVisible: boolean;
}

export const CareerCards = ({ data, isVisible }: CareerCardsProps) => {
  const isVisibleStyles = isVisible ? styles.isVisible : '';
  return (
    <article className={styles.cards}>
      <ul className={styles.positions_wrapper}>
        {data.positions.map((position) => (
          <li
            key={position.item}
            className={`${styles.position} ${isVisibleStyles}`}
          >
            {position.item}
          </li>
        ))}
        <li className={`${styles.slogan_wrapper} ${isVisibleStyles}`}>
          <div className={styles.photos}>
            {data.team_photos.map((item, index) => (
              <div
                className={styles.photo_wrapper}
                style={{ transform: `translate(${index * -20}%, 0)` }}
                key={item.photo.id}
              >
                <OptimizedPrismicImage field={item.photo} />
              </div>
            ))}
          </div>
          <p>{data.team_slogan}</p>
        </li>
      </ul>
      <div className={`${styles.image} ${isVisibleStyles}`}>
        <OptimizedPrismicImage field={data.image} />
      </div>
    </article>
  );
};
